import React from "react";
import Message from "../components/message";
import "../styles/aboutme.css";

const Aboutme = () => {
  return (
    <div className="aboutme-container">
      <div className="about-message-container">
        <div className="backgroundmessage">
          <Message
            title="Background"
            message={
                `
                Hi, I'm Edafe Merit,\n

                <strong>Full Stack Developer | Digital Health Enthusiast</strong>
                <br/>

                I transitioned from Anatomy and Public Health into Software Engineering, bringing a deep understanding of users, systems, and real-world problems into everything I build. My background helps me design and develop applications that are not just functional, but intuitive, accessible, and meaningful.

                I'm a graduate of the ALX Software Engineering Program and a HNG 12 and 13 Intern, where I worked in fast-paced, agile teams to ship production-ready features, collaborate across roles, and write clean, scalable code under tight deadlines.

                My core stack includes React, Node.js, TypeScript, Python, FastAPI, SQL, PostgreSQL and MongoDB. I've built applications that integrate REST APIs, payment systems, and AI-powered features, with a strong emphasis on performance, reliability, and user experience.

                Beyond coding, I enjoy refining UI/UX flows, exploring AI and machine learning, and sharpening my problem-solving skills on LeetCode and HackerRank. I'm especially passionate about building technology that improves healthcare access, information, and care delivery.

                <strong>Let's build something that truly matters.</strong>
                `}
          />
        </div>
      </div>
    </div>
  );
};

export default Aboutme;
